import { Divider, Text } from '@stone-payments/jade';
import { useIntl } from 'react-intl';

export function PaymentsDivider() {
  const { formatMessage } = useIntl();
  return (
    <div className="flex justify-between items-center my-4 gap-6" data-testid="payments-divider">
      <Divider direction="horizontal" size="small" />
      <Text color="medium" variant="overline">
        {formatMessage({ id: 'paymentDivider.or' })}
      </Text>
      <Divider direction="horizontal" size="small" />
    </div>
  );
}
